module.exports = __webpack_public_path__ + "static/media/PDF_109.4d76a9d8.pdf";